


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';

export const StaffAssetAuctionComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },

    // Nested FE info
    { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
    { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },

    // Asset3_2 notification details
    // { id: 'notification', field: 'notification', headerName: 'Notification', width: 150 },
      {
    id: 'notification',
    field: 'notification',
    headerName: 'Notification',
    width: 150,
    renderCell: (params) =>
      params.value && params.value !== '-' ? (
        <a
          href={params.value}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
        >
          View
        </a>
      ) : (
        <span>-</span>
      ),
  },
    { id: 'date', field: 'date', headerName: 'Date', width: 120 },
    { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },

    // Property Details
    { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
    { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
    { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },

    // Auction fields
    { id: 'khata_holder', field: 'khata_holder', headerName: 'Khata Holder', width: 200 },
    { id: 'date_of_auction', field: 'date_of_auction', headerName: 'Date of Auction', width: 140 },
    { id: 'final_bid_amt', field: 'final_bid_amt', headerName: 'Final Bid Amount', width: 150 },
    { id: 'success_bid_amt', field: 'success_bid_amt', headerName: 'Success Bid Amount', width: 150 },
    { id: 'gst', field: 'gst', headerName: 'GST', width: 100 },
    { id: 'tcs', field: 'tcs', headerName: 'TCS', width: 100 },
    { id: 'total', field: 'total', headerName: 'Total', width: 120 },
    { id: 'success_bidder_name', field: 'success_bidder_name', headerName: 'Success Bidder Name', width: 200 },
    { id: 'auction_amt', field: 'auction_amt', headerName: 'Auction Amount', width: 150 },
    { id: 'realized_amt', field: 'realized_amt', headerName: 'Realized Amount', width: 150 },
  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/asset-mgmt/asset-auction/`) 
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          name_of_fe: item.asset_property_base?.asset3_2_base?.fe?.name_of_fe || '-',
          name_of_ca: item.asset_property_base?.asset3_2_base?.fe?.name_of_ca || '-',
          notification: item.asset_property_base?.asset3_2_base?.notification || '-',
          date: item.asset_property_base?.asset3_2_base?.date
            ? new Date(item.asset_property_base.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          notification_no: item.asset_property_base?.asset3_2_base?.notification_no || '-',
          property_detals: item.asset_property_base?.property_detals || '-',
          survey_no: item.asset_property_base?.survey_no || '-',
          property_type: item.asset_property_base?.property_type || '-',

          khata_holder: item.khata_holder || '-',
          date_of_auction: item.date_of_auction
            ? new Date(item.date_of_auction).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          final_bid_amt: item.final_bid_amt || '-',
          success_bid_amt: item.success_bid_amt || '-',
          gst: item.gst || '-',
          tcs: item.tcs || '-',
          total: item.total || '-',
          success_bidder_name: item.success_bidder_name || '-',
          auction_amt: item.auction_amt || '-',
          realized_amt: item.realized_amt || '-',
        }));

        setRows(apiData);
        setSnackbarMessage('Asset Auction Master data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Asset Auction Master data:', error);
        setSnackbarMessage('Failed to load Asset Auction Master data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          Asset Auction Master
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
